class N {
  constructor() {
    this.core = {
      listeners: []
    };
  }
  listen(t, e) {
    document.addEventListener(t, e, !1), this.core.listeners.push({
      name: t,
      task: e
    });
  }
  destroy() {
    this.core.listeners.forEach((t) => {
      document.removeEventListener(t.name, t.task);
    });
  }
}
class I extends N {
  bind(t, e = {}) {
  }
  isEnabled() {
    return this.enabled === !0;
  }
  disable() {
    this.enabled = !1;
  }
  enable() {
    this.enabled = !0;
  }
  toggle() {
    this.enabled ? this.disable() : this.enable();
  }
}
function _(s) {
  return s && window.debug && window.debug.publish ? window.debug.publish.includes ? window.debug.publish.includes.includes(s) : window.debug.publish.excludes ? !window.debug.publish.excludes.includes(s) : window.debug.publish.log ?? !1 : !1;
}
function U(s, t = {}) {
  const e = this.core.subscribers[s];
  _(s) && (console.groupCollapsed(s), console.debug(t), window.debug.publish.trace && (console.groupCollapsed("trace"), console.trace(), console.groupEnd()), console.groupEnd()), Array.isArray(e) && Array.from(e).forEach((i) => {
    i.callback(t);
  });
}
function W(s, t, e) {
  if (b.isComponent(s) && s.hasFeature("publisher-subscriber")) {
    const i = {
      subscription_id: `${this._id}#${s._id}#${this.core.nbSubscriptions}`,
      callback: e
    };
    return i.unsubscribe = S.unsubscribeFactory(this, i, t, s), S.addSubscription(this, t, i, s), S.addSubscriber(this, t, i, s), i;
  } else
    return null;
}
function B(s = {}) {
  typeof s.message == "string" && (s.message = [s.message]), Array.isArray(s.message) && s.message.forEach((t) => {
    const e = this.core.subscriptions[t];
    Array.isArray(e) && e.map((r) => r.unsubscribe).forEach((r) => {
      r();
    });
  });
}
class S extends I {
  constructor(t = {}) {
    super(t);
  }
  init(t) {
    t.core.subscribers = {
      /**
       * message:
       * [
       *    {
       *       subscription_id: string,
       *       component_id: string,
       *       callback: function
       *    }
       * ]
       */
    }, t.core.subscriptions = {
      /**
       * message: {
       *      subscription_id: string,
       *      component_id: string
       *      callback: function
       * }
       */
    }, t.core.nbSubscriptions = 0, t.core.nbSubscribers = 0, t.publish = U.bind(t), t.subscribe = W.bind(t), t.unsubscribe = B.bind(t), this.destroy = S.destroy.bind(this, t);
  }
  /**
   * Add subscription to subscriber (aka component whose is asking for a subscription)
   * @param {SmartComponent} subscriber
   * @param {string} message
   * @param {{subscription_id: string, callback:function}} subscription
   * @param {SmartComponent} publisher
   */
  static addSubscription(t, e, i, r) {
    Array.isArray(t.core.subscriptions[e]) !== !0 && (t.core.subscriptions[e] = []), t.core.subscriptions[e].push({
      component_id: r._id,
      // data used for debug
      ...i
    }), t.core.nbSubscriptions++;
  }
  static unsubscribeFactory(t, e, i, r) {
    return () => {
      const n = r.core.subscribers[i];
      if (Array.isArray(n)) {
        const l = n.findIndex((h) => h.subscription_id === e.subscription_id);
        if (l >= 0) {
          const h = n.splice(l, 1);
          delete h.callback, r.core.nbSubscribers--, r.core.subscribers[i].length === 0 && delete r.core.subscribers[i];
        }
      }
      const a = t.core.subscriptions[i];
      if (Array.isArray(a)) {
        const l = a.findIndex((h) => h.subscription_id === e.subscription_id);
        if (l >= 0) {
          const h = a.splice(l, 1);
          delete h.unsubscribe, t.core.subscriptions[i].length === 0 && delete t.core.subscriptions[i], t.core.nbSubscriptions--;
        }
      }
    };
  }
  static addSubscriber(t, e, i, r) {
    Array.isArray(r.core.subscribers[e]) !== !0 && (r.core.subscribers[e] = []), r.core.subscribers[e].push({
      component_id: t._id,
      // data used for debug
      ...i
    }), r.core.nbSubscribers++;
  }
  static destroy(t) {
    Object.values(t.core.subscriptions).forEach((e) => {
      e.forEach((i) => i.unsubscribe());
    }), Object.values(t.core.subscribers).forEach((e) => {
      e.forEach((i) => i.unsubscribe());
    });
  }
}
function H(s, t = {}) {
  const e = new S(t);
  return e.init(s, t), e;
}
function V() {
}
let j = 0;
class b extends N {
  /**
   *
   * @param {SmartComponentSettings} settings
   */
  constructor(t = {}) {
    super(t), typeof t.component > "u" && (t.component = {}), Object.defineProperties(
      this.core,
      {
        instancied_at: {
          value: Date.now(),
          writable: !1,
          configurable: !1
        },
        _id: {
          value: "component_" + j++,
          writable: !1,
          configurable: !1
        },
        isSmartComponent: {
          value: !0,
          writable: !1,
          configurable: !1
        }
      }
    ), this._id = t._id || this.core._id, this.features = {
      "publisher-subscriber": {
        bindFeature: H,
        priority: -1
      }
    }, this.quietEvents = {}, this.setup(t);
  }
  static isComponent(t) {
    return typeof t == "object" && typeof t.core == "object" && t.core.isSmartComponent === !0;
  }
  featureIsEnabled(t) {
    const e = this.features[t];
    return typeof e != "object" || typeof e.isEnabled != "function" ? !1 : e.isEnabled() || !1;
  }
  is(t = null) {
    return t !== null && this._id === t._id;
  }
  store(t, e) {
    this.data[t] = e;
  }
  get(t) {
    return typeof this.data[t] < "u" ? this.data[t] : null;
  }
  setBehavior(t, e) {
    this.behaviours[t] = e;
  }
  /**
   * @param {string} featureName
   * @return {boolean} true is the feature is bind to component, false else
   */
  hasFeature(t) {
    return typeof this.features[t] < "u";
  }
  getBehavior(t) {
    return this.behaviours[t];
  }
  clearBehavior(t) {
    delete this.behaviours[t];
  }
  behave(t, e) {
    const i = this.getBehavior(t);
    if (typeof i == "function")
      return i(e);
  }
  hide(t) {
    t.classList.add("im-hidden");
  }
  show(t) {
    t.classList.remove("im-hidden");
  }
  doAsync(t) {
    new Promise((e) => {
      t(), e();
    }).then(V);
  }
  setup(t = {}) {
    typeof t.component.name < "u" ? this.name = t.component.name : typeof t.name < "u" ? this.name = t.name : this.name = this._id, this.ui = {}, this.label = {}, this.data = {}, this.behaviours = {}, this.onSetup(t), this.injectFeatures(Object.assign({}, t.component.features, t.features, this.features));
  }
  onSetup(t) {
  }
  setId(t) {
    this._id = t;
  }
  checkInjectionRulesBindTo(t, e) {
    if (typeof e.bindTo > "u")
      return !0;
    if (Array.isArray(e.bindTo)) {
      if (e.bindTo.has(this.name) === !1)
        return !1;
    } else {
      if (typeof e.bindTo == "function")
        return e.bindTo(this, e);
      if (this.name !== e.bindTo)
        return !1;
    }
    return !0;
  }
  checkInjectionBindMethod(t, e) {
    return typeof e == "function" ? !0 : (typeof e.bind > "u" && typeof e.bindFeature != "function" && (e.bindFeature = defaultSettings.featuresRecorded[t]), typeof e.bindFeature > "u" ? (this.notifyError(`Unable to find '${t}' in built-in viewer features`), !1) : !0);
  }
  checkInjectionRules(t, e) {
    return this.injectionRules.bindTo !== !0 && typeof e.bindTo < "u" || this.injectionRules.bindTo === !0 && this.checkInjectionRulesBindTo(t, e) !== !0 ? !1 : this.checkInjectionBindMethod(t, e) === !0;
  }
  injectFeatures(t = {}) {
    Object.keys(t).map((i) => {
      const r = {
        name: i
      }, n = t[i];
      return typeof n == "function" ? r.bindFeature = n : r.bindFeature = n.bindFeature, Number.isFinite(n.priority) ? r.priority = n.priority : r.priority = Number.POSITIVE_INFINITY, r;
    }).sort((i, r) => i.priority - r.priority).forEach((i) => {
      this.injectFeature(i.name, i.bindFeature);
    });
  }
  injectFeature(t, e = {}) {
    if (e === !1 || e.enabled === !1)
      return;
    let i;
    try {
      typeof e.bindFeature == "function" ? i = e.bindFeature(this, e) : typeof e == "function" && (i = e(this, e)), typeof i < "u" ? this.features[t] = i : this.features[t] = e, this.publish && this.publish("feature-added", { name: t, data: e });
    } catch (r) {
      this.notifyError(`Unable to bind feature "${t}" to component "${this.name}"`), console.error(r);
    }
    return !0;
  }
  quiet(t, e = !0) {
    e === !0 ? this.quietEvents[t] = !0 : delete this.quietEvents[t];
  }
  resetQuietEvents() {
    Object.keys(this.quietEvents).forEach((t) => {
      delete this.quietEvents[t];
    });
  }
  isQuiet(t) {
    return this.quietEvents[t] === !0;
  }
  emit(t, e = {}) {
    this.isQuiet(t) !== !0 && (e.target || document).dispatchEvent(
      this.createCustomEvent(
        t,
        Object.assign(
          {
            emitter: this
          },
          e
        )
      )
    );
  }
  destroy() {
    super.destroy(), this.publish("destroy", this), Object.values(this.features).forEach((t) => {
      typeof t.destroy == "function" && t.destroy();
    });
  }
  createCustomEvent(t, e) {
    if (typeof window < "u") {
      if (typeof window.CustomEvent == "function")
        return new CustomEvent(t, e);
      {
        const i = e || { bubbles: !1, cancelable: !1, detail: void 0 }, r = document.createEvent("CustomEvent");
        return r.initCustomEvent(t, i.bubbles, i.cancelable, i.detail), r;
      }
    }
  }
  /* Target annotations handled here */
  notifyWarning(t) {
    b.verboseMode && (console.log(`%c -- ${this.name} WARNING --`, "color: orange; font-weight:bold"), console.log(t));
  }
  notifyError(t, e = !1) {
    if (b.verboseMode && console.error(t), typeof window < "u" && window.newrelic && window.newrelic.noticeError(t), e === !0)
      throw new Error(t);
  }
  notifyLog(t) {
    console.log(`%c --  ${this.name} LOG --`, "color: blue; font-weight:bold"), console.log.apply(console, Array.prototype.slice.call(arguments));
  }
}
b.verboseMode = !0;
b.enableVerboseMode = function() {
  b.verboseMode = !0;
};
b.disableVerboseMode = function() {
  b.verboseMode = !1;
};
class O {
  constructor() {
    this.data = {
      coords: {
        x: 0,
        y: 0
      },
      lastCoords: {
        x: 0,
        y: 0
      },
      delta: {
        x: 0,
        y: 0
      },
      lastCoordsOnScreen: {
        x: 0,
        y: 0
      },
      lastMouseDownCoords: {
        x: 0,
        y: 0
      }
    }, this.isDown = !1, this.mouseDownTarget = null;
  }
  /**
   * @param {Number} x
   * @param {Number} y
   * @param {Number} sensivity
   * @param {Number} ratioX
   * @param {Number} ratioY
   */
  setCoords(t, e, i = 1, r = 1, n = 1) {
    const a = this.data.coords;
    this.setLastCoords(
      a.x,
      a.y
    ), a.x = t, a.y = e, this.data.delta.x = Math.round((a.x - this.data.lastCoords.x) * i * r), this.data.delta.y = Math.round((a.y - this.data.lastCoords.y) * i * n);
  }
  /**
   * @param {Number} x
   * @param {Number} y
   */
  setLastCoords(t, e) {
    const i = this.data.lastCoords;
    i.x = t, i.y = e;
  }
  getLastCoords() {
    const { x: t, y: e } = this.data.lastCoords;
    return { x: t, y: e };
  }
  /**
   * @param {Number} x
   * @param {Number} y
   */
  setLastMouseDownCoords(t, e) {
    const i = this.data.lastMouseDownCoords;
    i.x = t, i.y = e;
  }
  getLastMouseDownCoords() {
    const { x: t, y: e } = this.data.lastMouseDownCoords;
    return { x: t, y: e };
  }
  /**
   * @param {Element} target
   */
  setMouseDownTarget(t = null) {
    this.mouseDownTarget = t;
  }
  /**
   * @return {Element | null}
   */
  getMouseDownTarget() {
    return this.mouseDownTarget;
  }
  /**
   * @param {MouseEvent|TouchEvent} event
   */
  update(t) {
    const e = O.retrieveCoords(t), i = t.target;
    let r = 1, n = 1;
    if (Number.isFinite(i.width) && Number.isFinite(i.height)) {
      const a = i.getBoundingClientRect();
      r = i.width / a.width, n = i.height / a.height;
    }
    this.setCoords(e.x, e.y, 1, r, n);
  }
  /**
   * @param {MouseEvent|TouchEvent} event
   * @param {Element|null} relativeToElement
   * @return {{x: Number, y: Number}}
   */
  static retrieveCoords(t, e = null) {
    const r = (e || t.target).getBoundingClientRect();
    let n = t;
    return t.changedTouches && t.changedTouches[0] && (n = t.changedTouches[0]), {
      x: n.clientX - r.left,
      y: n.clientY - r.top
    };
  }
}
class L extends b {
  constructor(t) {
    typeof t.name > "u" && (t.name = "mouse-controller"), super(t), this.domTarget = t.domTarget || window, this.lockPointer = t.lockPointer || !1;
    const e = t.defaultIsAvoid ? L.avoid : null;
    this.onMouseMove = t.onMouseMove || e, this.onMouseDown = t.onMouseDown || e, this.onMouseUp = t.onMouseUp || e, this.onClick = t.onClick || e, this.onDoubleClick = t.onDoubleClick || e, this.onMouseEnter = t.onMouseEnter || e, this.onMouseLeave = t.onMouseLeave || e, this.onMouseWheel = t.onMouseWheel || e, this.onTouchStart = t.onTouchStart || t.onMouseDown || e, this.onTouchMove = t.onTouchMove || t.onMouseMove || e, this.onTouchEnd = t.onTouchEnd || t.onMouseUp || e, this.sensivity = 1, this.notify(), this.init(t);
  }
  init(t = {}) {
    if (typeof t.state < "u" ? this.state = t.state : this.state = new O(), this.lockPointer && this.requestPointerLock(), document.addEventListener("contextmenu", function(i) {
      return !1;
    }, !1), this.domTarget.addEventListener("contextmenu", function(i) {
      return i.preventDefault(), !1;
    }, !1), this.onMouseMove !== null && this.domTarget.addEventListener("mousemove", this.onMouseMove, !1), this.onMouseDown !== null && this.domTarget.addEventListener("mousedown", this.onMouseDown, !1), this.onMouseUp !== null && this.domTarget.addEventListener("mouseup", this.onMouseUp, !1), this.onClick !== null && this.domTarget.addEventListener("click", this.onClick, !1), this.onDoubleClick !== null && this.domTarget.addEventListener("dblclick", this.onDoubleClick, !1), this.onMouseEnter !== null && this.domTarget.addEventListener("mouseenter", this.onMouseEnter, !1), this.onMouseLeave !== null && this.domTarget.addEventListener("mouseleave", this.onMouseLeave, !1), this.onMouseWheel !== null && (this.domTarget.addEventListener("mousewheel", this.onMouseWheel, !1), this.domTarget.addEventListener("DOMMouseScroll", this.onMouseWheel, !1)), this.onTouchStart !== null) {
      var e = this;
      this.domTarget.addEventListener("touchstart", function(i) {
        e.onTouchStart(i);
      }, { passive: !1 });
    }
    if (this.onTouchMove !== null) {
      var e = this;
      this.domTarget.addEventListener("touchmove", this.onTouchMove, { passive: !1 });
    }
    this.onTouchEnd !== null && this.domTarget.addEventListener("touchend", this.onTouchEnd, !1);
  }
  isLeftClick(t) {
    return typeof t != "object" ? !1 : t.which == 1;
  }
  isRightClick(t) {
    return typeof t != "object" ? !1 : t.which === 3;
  }
  avoid() {
  }
  /* Get mouse coords from a canvas */
  getMouseCoords(t) {
    var e = t.target, i = e.getBoundingClientRect(), r, n;
    if (r = 1, n = 1, this.isTouchEvent(t))
      var a = (t.changedTouches[0].clientX - i.left) * r, l = (t.changedTouches[0].clientY - i.top) * n;
    else
      var a = (t.clientX - i.left) * r, l = (t.clientY - i.top) * n;
    return {
      x: a,
      y: l
    };
  }
  notify() {
    try {
      this.boundRect = this.domTarget.getBoundingClientRect();
    } catch (t) {
      this.boundRect ? (this.boundRect.width = this.domTarget.clientWidth, this.boundRect.height = this.domTarget.clientHeight) : this.boundRect = { width: this.domTarget.clientWidth, height: this.domTarget.clientHeight }, this.notifyError(t);
    }
    this.isTargetEmpty() ? (this.ratioX = 1, this.ratioY = 1) : (this.ratioX = Math.round(this.domTarget.width / this.boundRect.width), this.ratioY = Math.round(this.domTarget.height / this.boundRect.height));
  }
  isTargetEmpty() {
    return typeof this.domTarget.width > "u" || typeof this.domTarget.height > "u" || this.boundRect.width === 0 || this.boundRect.height === 0;
  }
  setCoords(t, e) {
    this.state.setCoords(
      t,
      e,
      this.sensivity,
      this.ratioX,
      this.ratioY
    );
  }
  isTouchEvent(t) {
    return t.changedTouches;
  }
  updateCoords(t) {
    let e;
    this.isTouchEvent() ? e = t.changedTouches[0] : e = t, this.setCoords(
      (e.clientX - this.boundRect.left) * this.ratioX,
      (e.clientY - this.boundRect.top) * this.ratioY
    );
  }
  /* Get mouse movement from a canvas */
  getPointerMovement(t) {
    t.target;
    var e = t._movementX * this.sensivity, i = t._movementY * this.sensivity;
    return e || (e = 0), i || (i = 0), {
      x: e,
      y: i
    };
  }
  /* Set mouse movement from a canvas (IE Compaptible) */
  setPointerMovement(t, e) {
    const i = this.state.data.lastCoordsOnScreen;
    return i.x && i.y && (t._movementX = parseFloat(e.x - i.x), t._movementY = parseFloat(e.y - i.y)), t;
  }
  requestPointerLock() {
    var t = this.domTarget;
    t.addEventListener("click", function() {
      t.requestPointerLock = t.requestPointerLock || t.mozRequestPointerLock || t.webkitRequestPointerLock, t.requestPointerLock && t.requestPointerLock();
    }, !1);
  }
  exitPointerLock() {
    document.exitPointerLock = document.exitPointerLock || document.mozExitPointerLock || document.webkitExitPointerLock, document.exitPointerLock();
  }
}
function z(s) {
  let t = "";
  return s.ctrlKey && (t += "ctrl+"), s.altKey && (t += "alt+"), s.metaKey && (t += "meta+"), s.shiftKey && (t += "shift+"), t;
}
class F {
  constructor(t = {}) {
    this.elementsExcluded = new Set(t.elementsExcluded || F.elementsExcluded);
    const e = t.eventsRecognized || F.eventsRecognized;
    this.handler = t.handler, this.component = t.component, this.keysFired = {}, e.forEach((i) => {
      document.addEventListener(i, (r) => {
        if (!this.isAllowed(r))
          return;
        const n = r.key.toLowerCase(), a = this.getHandler(r, n);
        if (typeof a > "u" || !this.shouldTriggerEvent(a, i, n) || typeof a[i] != "function") {
          this.handleEventKeyUpMetaKey(i, n);
          return;
        }
        a[i](r, this.component), this.handleEventKeyUpMetaKey(i, n);
      });
    });
  }
  shouldTriggerEvent(t, e, i) {
    return !(t.triggerOncePerPression && this.applyTriggerOncePerPressConstraint(e, i) !== !0);
  }
  getHandler(t, e) {
    let i = this.handler[`${z(t)}${e}`];
    return typeof i > "u" && typeof this.handler["*"] < "u" && (i = this.handler["*"]), i;
  }
  applyTriggerOncePerPressConstraint(t, e) {
    if (t === "keydown")
      return this.isFired(e) ? !1 : (this.fire(e), !0);
    if (t === "keyup")
      return this.unfire(e), !0;
  }
  isAllowed(t) {
    return !(this.isElementExcluded(t) || this.isContentEditable(t));
  }
  isElementExcluded(t) {
    return this.elementsExcluded.has(t.target.tagName.toLowerCase());
  }
  isContentEditable(t) {
    const e = t.target.getAttribute("contenteditable");
    return e !== null || typeof e == "string" && e.length > 0;
  }
  // https://stackoverflow.com/questions/5353254/javascript-onkeydown-event-fire-only-once
  isFired(t) {
    return this.keysFired[t] === !0;
  }
  fire(t) {
    this.keysFired[t] = !0;
  }
  unfire(t) {
    this.keysFired[t] = !1;
  }
  handleEventKeyUpMetaKey(t, e) {
    e !== "meta" || t !== "keyup" || Object.keys(this.keysFired).forEach((i) => {
      this.keysFired[i] = !1;
    });
  }
}
F.elementsExcluded = /* @__PURE__ */ new Set([
  "textarea",
  "input"
]);
F.eventsRecognized = /* @__PURE__ */ new Set([
  "keydown",
  "keyup"
]);
function o(s, t, e) {
  this.data = s !== void 0 ? [s, t, e] : [0, 0, 0];
}
o.initialized = !1;
o.POOL = {
  instances: [],
  avaibles: [],
  initialSize: 10
};
o.initialize = function() {
  if (o.initialized === !1) {
    for (var s = 0; s < o.POOL.initialSize; ++s) {
      var t = new o();
      o.POOL.instances.push(t), o.POOL.avaibles.push(t);
    }
    o.initialized = !0;
  }
};
o.getComplementOfCouple = function(s, t) {
  return t[0].equals(s[0]) || t[0].equals(s[1]) ? t[1] : t[0];
};
o.fromPoints = function(s, t) {
  return new o(t.getX() - s.getX(), t.getY() - s.getY(), t.getZ() - s.getZ());
};
o.local = function(s, t, e) {
  return new o(s, t, e);
};
o.use = function(r, n, a) {
  var i, r = r || 0, n = n || 0, a = a || 0;
  return o.POOL.avaibles.length > 0 ? i = o.POOL.avaibles.pop() : (i = new o(), o.POOL.instances.push(i)), i.set(r, n, a), i.inUse = !0, i;
};
o.getOne = function(r, n, a) {
  var i, r = r || 0, n = n || 0, a = a || 0;
  return o.POOL.avaibles.length > 0 ? i = o.POOL.avaibles.pop() : (i = new o(), o.POOL.instances.push(i)), i.set(r, n, a), i.inUse = !0, i;
};
o.getInstance = function(s) {
  return s === !0 ? o.use() : new o();
};
o.determinant = function(s, t) {
  return s.getX() * t.getY() - s.getY() * t.getX();
};
o.det3x3 = function(s, t, e) {
  var i = s[0], r = t[0], n = e[0], a = s[1], l = t[1], h = e[1], u = s[2], d = t[2], p = e[2];
  return i * (l * p - d * h) + a * (d * n - p * r) + u * (r * h - l * n);
};
o.prototype.inUse = !1;
o.prototype.recycle = function() {
  this.inUse === !0 && (this.inUse = !1, o.POOL.avaibles.push(this));
};
o.prototype.setX = function(s) {
  return this.data[0] = s, this;
};
o.prototype.setY = function(s) {
  return this.data[1] = s, this;
};
o.prototype.setZ = function(s) {
  return this.data[2] = s, this;
};
o.prototype.getX = function(s) {
  return this.data[0];
};
o.prototype.getY = function(s) {
  return this.data[1];
};
o.prototype.getZ = function() {
  return this.data[2];
};
o.prototype.set = function(s, t, e) {
  return this.data[0] = s, this.data[1] = t, this.data[2] = e, this;
};
o.prototype.affect = function(s) {
  return this.data[0] = s.data[0], this.data[1] = s.data[1], this.data[2] = s.data[2], this;
};
o.prototype.getNorm = function() {
  return Math.sqrt(this.data[0] * this.data[0] + this.data[1] * this.data[1] + this.data[2] * this.data[2]);
};
o.prototype.getNorm2 = function() {
  return this.data[0] * this.data[0] + this.data[1] * this.data[1] + this.data[2] * this.data[2];
};
o.prototype.normalize = function() {
  var s = this.getNorm();
  return s > 0 && this.set(
    this.data[0] / s,
    this.data[1] / s,
    this.data[2] / s
  ), this;
};
o.prototype.isNull = function() {
  return this.data[0] === 0 && this.data[1] === 0 && this.data[2] === 0;
};
o.prototype.cross = function(s, t) {
  var e = o.use().affect(s), i = o.use().affect(t);
  return this.set(
    e.data[1] * i.data[2] - e.data[2] * i.data[1],
    e.data[2] * i.data[0] - e.data[0] * i.data[2],
    e.data[0] * i.data[1] - e.data[1] * i.data[0]
  ), e.recycle(), i.recycle(), this;
};
o.prototype.round = function(s) {
  return this.set(
    Math.round(this.data[0] * s) / s,
    Math.round(this.data[1] * s) / s,
    Math.round(this.data[2] * s) / s
  ), this;
};
o.prototype.approxEqual = function(s) {
  return this.distance(s) < 0.1;
};
o.prototype.isInSpace = function(s, t) {
  return t === void 0 && (t = 0), this.data[0] < s.minX - t || this.data[1] < s.minY - t || this.data[2] < s.minZ - t || this.data[0] > s.maxX + t || this.data[1] > s.maxY + t || this.data[2] > s.maxZ + t;
};
o.prototype.isInSpace2D = function(s, t) {
  return t === void 0 && (t = 0), this.data[0] < s.minX - t || this.data[1] < s.minY - t || this.data[0] > s.maxX + t || this.data[1] > s.maxY + t;
};
o.prototype.copy = function(s) {
  return o.getInstance(s).set(this.data[0], this.data[1], this.data[2]);
};
o.prototype.equals = function(s) {
  return this.data[0] === s.data[0] && this.data[1] === s.data[1] && this.data[2] === s.data[2];
};
o.prototype.distance = function(s) {
  return Math.sqrt(
    (s.data[0] - this.data[0]) * (s.data[0] - this.data[0]) + (s.data[1] - this.data[1]) * (s.data[1] - this.data[1]) + (s.data[2] - this.data[2]) * (s.data[2] - this.data[2])
  );
};
o.prototype.angle = function(s) {
  var t = this.scalar(s) / (this.getNorm() * s.getNorm());
  function e(i, r, n) {
    return i <= r ? r : i >= n ? n : i;
  }
  return Math.acos(e(t, -1, 1));
};
o.prototype.signedAngleXY = function(s) {
  return Math.atan2(this.getX() * s.getY() - this.getY() * s.getX(), this.getX() * s.getX() + this.getY() * s.getY());
};
o.prototype.rotateZ = function(s, t) {
  var e = this.data[0] - s.data[0], i = this.data[1] - s.data[1], r = this.data[2] - s.data[2];
  return this.set(
    e * Math.cos(t) - i * Math.sin(t) + s.data[0],
    e * Math.sin(t) + i * Math.cos(t) + s.data[1],
    r + s.data[2]
  ), this;
};
o.prototype.get = function(s) {
  return this.data[s];
};
o.from2D = function(s, t, e) {
  return o.getInstance(e).set(s, t, 0);
};
o.prototype.scalar = function(s) {
  return this.data[0] * s.data[0] + this.data[1] * s.data[1] + this.data[2] * s.data[2];
};
o.prototype.isColinear = function(s) {
  for (var t = 0; s.data[t] === 0 && t < s.data.length; ) t++;
  if (t === s.length - 1) return !1;
  for (var e = this.data[t] / s.data[t], i = !0, r = 0; r < this.data.length; ++r)
    s.data[r] !== 0 && (e > this.data[r] / s.data[r] - 0.1 && e < this.data[r] / s.data[r] + 0.1 || (i = !1));
  return i && e !== 0;
};
o.prototype.minus = function(s, t) {
  return o.getInstance(t).set(
    this.data[0] - s.data[0],
    this.data[1] - s.data[1],
    this.data[2] - s.data[2]
  );
};
o.prototype.plus = function(s, t) {
  return o.getInstance(t).set(
    this.data[0] + s.data[0],
    this.data[1] + s.data[1],
    this.data[2] + s.data[2]
  );
};
o.prototype.add = function(s) {
  return this.set(
    this.data[0] + s.data[0],
    this.data[1] + s.data[1],
    this.data[2] + s.data[2]
  ), this;
};
o.prototype.substract = function(s) {
  return this.set(
    this.data[0] - s.data[0],
    this.data[1] - s.data[1],
    this.data[2] - s.data[2]
  ), this;
};
o.prototype.divideScalar = function(s) {
  return s !== 0 && this.set(
    this.data[0] / s,
    this.data[1] / s,
    this.data[2] / s
  ), this;
};
o.prototype.multiplyScalar = function(s) {
  return this.set(
    this.data[0] * s,
    this.data[1] * s,
    this.data[2] * s
  ), this;
};
o.prototype.distance = function(s) {
  var t = this.minus(s), e = t.getNorm();
  return e;
};
o.prototype.transformMat4 = function(s, t) {
  var e = s.data[0], i = s.data[1], r = s.data[2], n = t[3] * e + t[7] * i + t[11] * r + t[15];
  return n = n || 1, this.set(
    (t[0] * e + t[4] * i + t[8] * r + t[12]) / n,
    (t[1] * e + t[5] * i + t[9] * r + t[13]) / n,
    (t[2] * e + t[6] * i + t[10] * r + t[14]) / n
  ), this;
};
o.prototype.translate = function(s, t, e) {
  return t === void 0 ? this.set(
    this.data[0] - s.data[0],
    this.data[1] - s.data[1],
    this.data[2] - s.data[2]
  ) : this.set(
    this.data[0] + s,
    this.data[1] + t,
    this.data[2] + e
  ), this;
};
o.prototype.inverseSens = function() {
  return this.data[0] *= -1, this.data[1] *= -1, this.data[2] *= -1, this;
};
o.prototype.scale = function(s = 1, t = 1, e = 1) {
  return this.data[0] *= s, this.data[1] *= t, this.data[2] *= e, this;
};
o.prototype.transfert = function(s) {
  this.affect(s(this));
};
o.prototype.swap = function(s) {
  var t = s.data[0], e = s.data[1], i = s.data[2];
  return s.data[0] = this.data[0], s.data[1] = this.data[1], s.data[2] = this.data[2], this.set(t, e, i), this;
};
o.prototype.movePoint = function(s, t) {
  this.set(
    this.data[0] + s * t.getX(),
    this.data[1] + s * t.getY(),
    this.data[2] + s * t.getZ()
  );
};
o.prototype.getIndexOfAbsoluteComposanteMax = function() {
  var s = 0, t = 0;
  return this.data.forEach(function(e, i) {
    var r = Math.abs(e);
    s < r && (s = r, t = i);
  }), t;
};
o.prototype.isValid = function() {
  const s = this.data[0], t = this.data[1], e = this.data[2];
  return Number.isFinite(s) && Number.isFinite(t) && Number.isFinite(e);
};
o.prototype.toString = function() {
  return `[x: ${this.data[0]}|y: ${this.data[1]}|z: ${this.data[2]}]`;
};
o.prototype.translateAlongVector = function(s) {
  this.translate(s.getX(), s.getY(), s.getZ());
};
o.initialize();
typeof window < "u" && typeof window.Vec3 > "u" && (window.Vec3 = o);
const M = {
  getXByDistanceAndAngle(s, t, e) {
    return s + Math.cos(e % 360 * Math.PI / 180) * t;
  },
  getYByDistanceAndAngle(s, t, e) {
    return s + Math.sin(e % 360 * Math.PI / 180) * -1 * t;
  },
  getReverseAngle(s) {
    var t = (s + 180) % 360;
    return t;
  },
  getAngleBetween2XY(s, t, e, i) {
    var r = i - t, n = e - s, a = Math.atan2(-r, n);
    a < 0 && (a += 2 * Math.PI);
    var l = a * 180 / Math.PI;
    return l;
  },
  getDistanceBetween2XY(s, t, e, i) {
    var r = Math.pow(e - s, 2), n = Math.pow(t - i, 2), a = Math.sqrt(r + n);
    return a;
  },
  rotatePointAroundCenter(s, t, e, i, r) {
    var n = Math.PI / 180 * r, a = Math.cos(n), l = Math.sin(n), h = a * (e - s) + l * (i - t) + s, u = a * (i - t) - l * (e - s) + t;
    return {
      x: h,
      y: u
    };
  },
  getCartesianEquationOfLine(s, t) {
    var e = t.getY() - s.getY(), i = s.getX() - t.getX();
    return {
      a: e,
      b: i,
      c: -(s.getY() * i + e * s.getX())
    };
  },
  // https://github.com/mattdesl/point-circle-collision/blob/master/index.js
  pointCircleCollide(s, t, e, i = !1) {
    if (e === 0)
      return !1;
    const r = t[0] - s[0], n = t[1] - s[1], a = r * r + n * n, l = a <= e * e;
    return i === !0 ? {
      distance: Math.sqrt(a),
      hasCollision: l
    } : l;
  },
  // https://www.npmjs.com/package/line-circle-collision
  lineCircleCollide(s, t, e, i, r) {
    if (M.pointCircleCollide(s, e, i))
      return r && (r[0] = s[0], r[1] = s[1]), !0;
    if (M.pointCircleCollide(t, e, i))
      return r && (r[0] = t[0], r[1] = t[1]), !0;
    const n = s[0], a = s[1], l = t[0], h = t[1], u = e[0], d = e[1], p = l - n, y = h - a, P = u - n, C = d - a, v = p * p + y * y;
    let E = p, c = y;
    if (v > 0) {
      const k = (P * p + C * y) / v;
      E *= k, c *= k;
    }
    r || (r = [0, 0]), r[0] = n + E, r[1] = a + c;
    const m = E * E + c * c;
    return M.pointCircleCollide(r, e, i) && m <= v && E * p + c * y >= 0;
  },
  distancePointToLine2D: function(s, t, e) {
    var i = M.getCartesianEquationOfLine(t, e), r = Math.abs(i.a * s.getX() + i.b * s.getY() + i.c), n = i.a * i.a + i.b * i.b;
    return r / Math.sqrt(n);
  },
  distancePointToEdge2D: function(s, t, e, i) {
    const r = s.distance(t), n = t.distance(e), a = s.distance(e), l = n + i, h = r < l, u = a < l;
    return h && u ? M.distancePointToLine2D(s, t, e) : Math.min(r, a);
  },
  /** Solve a linear system of equations given by a (n + 1) * n matrix with a result vector n + 1 */
  gauss: function(s) {
    for (var t = 3, e = 0; e < t; e++) {
      for (var i = Math.abs(s[e][e]), r = e, n = e + 1; n < t; n++)
        Math.abs(s[n][e]) > i && (i = Math.abs(s[n][e]), r = n);
      for (var n = e; n < t + 1; n++) {
        var a = s[r][n];
        s[r][n] = s[e][n], s[e][n] = a;
      }
      for (n = e + 1; n < t; n++)
        for (var l = -s[n][e] / s[e][e], h = e; h < t + 1; h++)
          e == h ? s[n][h] = 0 : s[n][h] += l * s[e][h];
    }
    for (var u = new Array(t), e = t - 1; e > -1; e--) {
      u[e] = s[e][e] === 0 ? 0 : s[e][t] / s[e][e];
      for (var n = e - 1; n > -1; n--)
        s[n][t] -= s[n][e] * u[e];
    }
    return u;
  },
  getCartesianEquationOfPlane: function(s, t, e) {
    var i = new o();
    return e !== void 0 ? i.cross(t, e) : i.affect(t), {
      a: i.getX(),
      b: i.getY(),
      c: i.getZ(),
      d: -i.getX() * s.getX() - i.getY() * s.getY() - i.getZ() * s.getZ()
    };
  },
  /**
   * Compute a 2D Line intersection with two points of each line
   * @param {Vec3} a first point of first line
   * @param {Vec3} b second point of second line
   * @param {Vec3} u first point of second line
   * @param {Vec3} v second point of second line
   * @returns {Vec3} the intersection point. If no intersection found, (x, y, z) = (null, null, null).
   */
  intersection2D: function(s, t, e, i) {
    var r = s.getX() - t.getX(), n = s.getY() - t.getY(), a = e.getX() - i.getX(), l = e.getY() - i.getY(), h = r * l - n * a;
    if (Math.abs(h) < 0.01)
      return new o(null, null, null);
    var u = s.getX() * t.getY() - s.getY() * t.getX(), d = e.getX() * i.getY() - e.getY() * i.getX(), p = (u * a - d * r) / h, y = (u * l - d * n) / h;
    return new o(p, y, 0);
  },
  AABBRayIntersection: function(s, t, e) {
    var i = o.use(
      s.min.getX(),
      s.min.getY(),
      0
    ), r = o.use(
      s.max.getX(),
      s.min.getY(),
      0
    ), n = o.use(
      s.min.getX(),
      s.max.getY(),
      0
    ), a = o.use(
      s.max.getX(),
      s.max.getY(),
      0
    ), l = [];
    l.push(M.intersection2D(i, r, t, e)), l.push(M.intersection2D(i, n, t, e)), l.push(M.intersection2D(r, a, t, e)), l.push(M.intersection2D(n, a, t, e));
    var h = [];
    return l.forEach(function(u) {
      u.getX() !== null && s.containsPoint(u) === !0 && h.push(u);
    }), i.recycle(), r.recycle(), n.recycle(), a.recycle(), h;
  }
};
let K = class {
  /**
   * Created by Mickael.Berger on 28/04/16.
   */
  constructor(t, e, i, r, n, a) {
    this.svg = document.createElementNS("http://www.w3.org/2000/svg", "svg"), this.matrix = this.svg.createSVGMatrix(), this.setTransform(t, e, i, r, n, a);
  }
  setTransformMatrix(t) {
    this.matrix = t;
  }
  getTransformMatrix() {
    return this.matrix;
  }
  scale(t, e) {
    this.matrix = this.matrix.scaleNonUniform(t, e);
  }
  rotate(t) {
    this.matrix = this.matrix.rotate(t * 180 / Math.PI);
  }
  translate(t, e) {
    this.matrix = this.matrix.translate(t, e);
  }
  setTransform(t, e, i, r, n, a) {
    this.matrix.a = t, this.matrix.b = e, this.matrix.c = i, this.matrix.d = r, this.matrix.e = n, this.matrix.f = a;
  }
  transform(t, e, i, r, n, a) {
    var l = this.svg.createSVGMatrix();
    l.a = t, l.b = e, l.c = i, l.d = r, l.e = n, l.f = a, this.matrix = this.matrix.multiply(l);
  }
  transformCoordinates(t, e) {
    var i = this.svg.createSVGPoint();
    return i.x = parseFloat(t), i.y = parseFloat(e), i.matrixTransform(this.matrix.inverse());
  }
  multiply(t) {
    this.matrix.multiply(t);
  }
  getComputedScaleX() {
    return Math.sqrt(this.matrix.a * this.matrix.a + this.matrix.c * this.matrix.c);
  }
  getComputedScaleY() {
    return Math.sqrt(this.matrix.d * this.matrix.d + this.matrix.b * this.matrix.b);
  }
  getTx() {
    return this.matrix.e;
  }
  getTy() {
    return this.matrix.f;
  }
  getScaleX() {
    return this.matrix.a;
  }
  getScaleY() {
    return this.matrix.d;
  }
  getSkewX() {
    return this.matrix.b;
  }
  getSkewY() {
    return this.matrix.c;
  }
  flipX() {
    this.matrix = this.matrix.flipX();
  }
  flipY() {
    this.matrix = this.matrix.flipY();
  }
};
const Z = 1, G = 0;
class g {
  /**
   *
   * @param settings
   * @param {number} settings.addStatusId
   * @param {HTMLDivElement} settings.canvasDiv
   * @param {number} settings.width
   * @param {number} settings.height
   * @param {string} settings.cssZIndex
   * @param {string} settings.cssPosition
   * @param {string} settings.cssPointerEvents
   * @param {boolean} settings.useMouseController
   */
  constructor(t) {
    const e = t.width, i = t.height;
    switch (this.canvasTag = document.createElement("canvas"), this.canvasTag.width = e, this.canvasTag.height = i, this.canvasTag.style.zIndex = t.cssZIndex, this.canvasTag.style.position = t.cssPosition, this.canvasTag.style.pointerEvents = t.cssPointerEvents, this.context = this.canvasTag.getContext("2d"), this.context.shadowOffsetX = 0, this.context.shadowOffsetY = 0, this.context.shadowBlur = 0, this.context.shadowColor = null, this.transformMatrix = new K(1, 0, 0, 1, 0, 0), this.canvasWidth = e, this.canvasHeight = i, this.savedTransforms = [], this.baseLineForText = "top", this.container = t.canvasDiv, t.addStatusId) {
      case Z:
        this.container.appendChild(this.canvasTag);
        break;
      case G:
        this.container.insertBefore(this.canvasTag, this.container.firstChild);
        break;
      default:
        throw 'missing "addStatusId" parameter';
    }
    this.ellipsisWidth = 0, this.ellipsis = "...", this.space = " ", this.spaceWidth = 0, t.useMouseController !== !1 && this.setupListener(), this.resize(e, i);
  }
  /**
   * @public
   * @return {HTMLDivElement}
   */
  getContainer() {
    return this.container;
  }
  /**
   * @private
   */
  setupListener() {
    const t = this;
    this.mouseController = new L({
      name: "icanvas-mouse-controller",
      domTarget: t.canvasTag,
      defaultIsAvoid: !0
    });
  }
  getImageUrl() {
    return this.canvasTag.toDataURL("image/png");
  }
  saveImage() {
    window.open(this.canvasTag.toDataURL("image/jpeg", 1));
  }
  getCanvasHeight() {
    return this.canvasHeight;
  }
  setCanvasHeight(t) {
    return t = Math.floor(t), this.canvasTag.height !== t && (this.canvasTag.height = t, this.canvasHeight = t), this.canvasHeight;
  }
  getCanvasWidth() {
    return this.canvasWidth;
  }
  setCanvasWidth(t) {
    return t = Math.floor(t), this.canvasTag.width !== t && (this.canvasTag.width = t, this.canvasWidth = t), this.canvasWidth;
  }
  setOnMouseDown(t) {
    this.mouseController.onMouseDown = t, this.mouseController.onTouchStart = t;
  }
  setOnMouseMove(t) {
    this.mouseController.onMouseMove = t, this.mouseController.onTouchMove = t;
  }
  setOnMouseUp(t) {
    this.mouseController.onMouseUp = t, this.mouseController.onTouchEnd = t;
  }
  setOnMouseEnter(t) {
    this.mouseController.onMouseEnter = t;
  }
  setOnMouseLeave(t) {
    this.mouseController.onMouseLeave = t;
  }
  setOnMouseOut(t) {
    this.mouseController.onMouseOut = t;
  }
  setOnMouseWheel(t) {
    this.mouseController.onMouseWheel = t;
  }
  setOnClick(t) {
    this.mouseController.onClick = t;
  }
  setOnDoubleClick(t) {
    this.mouseController.onDoubleClick = t;
  }
  setKeyDownHandler(t) {
    document.addEventListener("keydown", t);
  }
  setId(t) {
    this.canvasTag.setAttribute("id", t);
  }
  setCss(t, e) {
    $(this.canvasTag).css(t, e);
  }
  setLineWidth(t) {
    this.context.lineWidth = t;
  }
  getOffset() {
    return { left: this.canvasTag.offsetLeft, top: this.canvasTag.offsetTop };
  }
  setTextBaseline(t) {
    this.baseLineForText = t, this.context.textBaseline = this.baseLineForText;
  }
  setTextAlign(t) {
    this.context.textAlign = t;
  }
  setFillStyle(t) {
    this.context.fillStyle = t;
  }
  setStrokeStyle(t) {
    this.context.strokeStyle = t;
  }
  beginPath() {
    this.context.beginPath();
  }
  moveTo(t, e) {
    this.context.moveTo(t, e);
  }
  lineTo(t, e) {
    this.context.lineTo(t, e);
  }
  stroke() {
    this.context.stroke();
  }
  drawLine(t) {
    const e = this.context;
    e.fillStyle = t.color, e.strokeStyle = t.color, e.beginPath(), e.moveTo(Math.floor(t.a.getX()), Math.floor(t.a.getY())), e.lineTo(Math.floor(t.b.getX()), Math.floor(t.b.getY())), e.fill(), e.stroke(), e.closePath();
  }
  drawImage(t, e, i, r, n) {
    r && n ? this.context.drawImage(t, e, i, r, n) : this.context.drawImage(t, e, i);
  }
  fillCircle(t, e, i, r, n) {
    this.context.beginPath(), this.context.arc(t, e, i, 0, 2 * Math.PI, !1);
    const a = g.getColorFromHex(n);
    this.context.fillStyle = "rgba(" + a.r + "," + a.g + "," + a.b + "," + r + ")", this.context.fill(), g.recycleColor(a);
  }
  strokeCircle(t, e, i, r, n, a) {
    this.context.beginPath(), this.context.arc(t, e, i, 0, 2 * Math.PI, !1);
    var l = g.getColorFromHex(n);
    this.context.lineWidth = a, this.context.strokeStyle = "rgba(" + l.r + "," + l.g + "," + l.b + "," + r + ")", this.context.stroke(), g.recycleColor(l);
  }
  fillEllipsis(t, e, i, r, n, a, l) {
    this.context.beginPath(), this.context.ellipse(t, e, i, r, n, 0, Math.PI * 2, !1);
    var h = g.getColorFromHex(l);
    this.context.fillStyle = "rgba(" + h.r + "," + h.g + "," + h.b + "," + a + ")", this.context.fill(), g.recycleColor(h);
  }
  strokeEllipsis(t, e, i, r, n, a, l, h) {
    this.context.beginPath(), this.context.ellipse(t, e, Math.abs(i), Math.abs(r), n, 0, Math.PI * 2, !1), this.context.lineWidth = h;
    var u = g.getColorFromHex(l);
    this.context.strokeStyle = "rgba(" + u.r + "," + u.g + "," + u.b + "," + a + ")", this.context.stroke(), g.recycleColor(u);
  }
  drawRect(t, e, i, r, n, a) {
    this.context.beginPath(), this.context.rect(t, e, i, r);
    const l = g.getColorFromHex(a);
    this.context.fillStyle = "rgba(" + l.r + "," + l.g + "," + l.b + "," + n + ")", this.context.fill(), g.recycleColor(l);
  }
  strokeRect(t, e, i, r, n, a) {
    this.context.beginPath(), this.context.rect(t, e, i, r);
    const l = g.getColorFromHex(a);
    this.context.strokeStyle = "rgba(" + l.r + "," + l.g + "," + l.b + "," + n + ")", this.context.stroke(), g.recycleColor(l);
  }
  fillRect(t, e, i, r, n, a) {
    this.context.beginPath(), this.context.rect(t, e, i, r);
    const l = g.getColorFromHex(a);
    this.context.fillStyle = "rgba(" + l.r + "," + l.g + "," + l.b + "," + n + ")", this.context.fill(), g.recycleColor(l);
  }
  clearCanvas(t = 0, e = 0, i = this.getCanvasWidth(), r = this.getCanvasHeight(), n = !1) {
    n === !0 && (this.saveCanvas(), this.setTransform(1, 0, 0, 1, 0, 0)), this.context.clearRect(t, e, i, r), n === !0 && this.restoreCanvas();
  }
  saveCanvas() {
    this.savedTransforms.push(new TransformMatrix(this.getScaleX(), this.getSkewX(), this.getSkewY(), this.getScaleY(), this.getTx(), this.getTy())), this.context.save();
  }
  restoreCanvas() {
    this.transformMatrix = this.savedTransforms.pop(), this.context.restore();
  }
  setGlobalAlpha(t) {
    this.context.globalAlpha = t;
  }
  resize(t, e) {
    this.canvasWidth = t, this.canvasHeight = e, this.canvasTag.width = t, this.canvasTag.height = e, this.context.textBaseline = this.baseLineForText;
  }
  getTransformMatrix() {
    return this.transformMatrix;
  }
  scale(t, e) {
    this.transformMatrix.scale(t, e), this.context.scale(t, e);
  }
  rotate(t) {
    this.transformMatrix.rotate(t), this.context.rotate(t);
  }
  translate(t, e) {
    this.transformMatrix.translate(t, e), this.context.translate(t, e);
  }
  setTransform(t, e, i, r, n, a) {
    this.transformMatrix.setTransform(t, e, i, r, n, a), this.context.setTransform(t, e, i, r, n, a);
  }
  transform(t, e, i, r, n, a) {
    this.transformMatrix.transform(t, e, i, r, n, a), this.context.transform(t, e, i, r, n, a);
  }
  transformCoordinates(t, e) {
    return this.transformMatrix.transformCoordinates(t, e);
  }
  getTx() {
    return this.transformMatrix.getTx();
  }
  getTy() {
    return this.transformMatrix.getTy();
  }
  getComputedScaleX(t) {
    return (t ? -1 : 1) * this.transformMatrix.getComputedScaleX();
  }
  getComputedScaleY(t) {
    return t ? -this.transformMatrix.getComputedScaleY() : this.transformMatrix.getComputedScaleY();
  }
  getScaleX() {
    return this.transformMatrix.getScaleX();
  }
  getScaleY() {
    return this.transformMatrix.getScaleY();
  }
  getSkewX() {
    return this.transformMatrix.getSkewX();
  }
  getSkewY() {
    return this.transformMatrix.getSkewY();
  }
  flipX() {
    this.transformMatrix.flipX(), this.setTransform(-this.transformMatrix.getScaleX(), -this.transformMatrix.getSkewX(), -this.transformMatrix.getSkewY(), this.transformMatrix.getScaleY(), this.transformMatrix.getTx(), this.transformMatrix.getTy());
  }
  flipX2() {
    this.transformMatrix.flipX(), this.setTransform(this.transformMatrix.getScaleX(), -this.transformMatrix.getSkewX(), this.transformMatrix.getSkewY(), this.transformMatrix.getScaleY(), this.transformMatrix.getTx(), this.transformMatrix.getTy());
  }
  flipY2() {
    this.transformMatrix.flipY(), this.setTransform(-this.transformMatrix.getScaleX(), -this.transformMatrix.getSkewX(), -this.transformMatrix.getSkewY(), this.transformMatrix.getScaleY(), this.transformMatrix.getTx(), this.transformMatrix.getTy());
  }
  flipXY() {
    this.transformMatrix.flipX(), this.setTransform(-this.transformMatrix.getScaleX(), this.transformMatrix.getSkewX(), this.transformMatrix.getSkewY(), this.transformMatrix.getScaleY(), this.transformMatrix.getTx(), this.transformMatrix.getTy());
  }
  flipY() {
    this.transformMatrix.flipY(), this.setTransform(this.transformMatrix.getScaleX(), this.transformMatrix.getSkewX(), -this.transformMatrix.getSkewY(), this.transformMatrix.getScaleY(), this.transformMatrix.getTx(), this.transformMatrix.getTy());
  }
  measureTextInCanvas(t) {
    return this.context.measureText(t).width;
  }
  stringEllipsis(t, e, i) {
    let r = this.context.measureText(t).width;
    if (r < e && i === !1)
      return t;
    {
      let n = t.length;
      for (; r >= e - this.ellipsisWidth && n-- > 0; )
        t = t.substring(0, n), r = this.context.measureText(t).width;
      return t + this.ellipsis;
    }
  }
  drawMultilineText(t, e, i, r, n, a, l, h) {
    if (h === !1)
      var u = Math.ceil(e + r);
    else
      var u = Math.ceil(e);
    var d = Math.ceil(i), p = this.context.measureText(t).width, y = 0;
    if (p > r) {
      for (var P = this, C = t.split(this.space), v = C.map(function(q) {
        return P.context.measureText(q).width;
      }), E = !1, c = 0, m = 0, f = 0, k = 0, x = 0; x < a; ++x) {
        for (; c < v.length && f < r; )
          f += v[c], ++c;
        if (f > r && c > m + 1 && (--c, f -= v[c]), x == 0 && (k = f), x < a - 1)
          this.context.fillText(C.slice(m, c).join(" "), u, d + n * x), f += (c - m) * this.spaceWidth;
        else if (c - m === 0 && c < C.length) {
          ++c, f += v[c], E = !0;
          var w = C.slice(m, c).join(this.space), R = this.context.measureText(w).width;
          R < r ? (w = this.stringEllipsis(w, r, c < v.length), f += (c - m) * this.spaceWidth + this.ellipsisWidth) : f += (c - m) * this.spaceWidth, this.context.fillText(w, u, d + n * x);
        } else if (c - m !== 0 && c <= C.length) {
          E = !0;
          var w = C.slice(m, c).join(this.space), R = this.context.measureText(w).width;
          R < r ? (w = this.stringEllipsis(w, r, c < v.length), f += (c - m) * this.spaceWidth + this.ellipsisWidth) : f += (c - m) * this.spaceWidth, this.context.fillText(w, u, d + n * x);
        }
        y < f && (y = f), l && (f = Math.ceil(f), this.context.beginPath(), h === !1 ? (this.context.moveTo(u, d + 2 + n * (x + 1)), this.context.lineTo(u - f, d + 2 + n * (x + 1))) : (this.context.moveTo(u, d + 2 + n * (x + 1)), this.context.lineTo(u + f, d + 2 + n * (x + 1))), this.context.stroke()), f = 0, m = c;
      }
      return {
        lengthOfFirstLine: (E === !0 ? -1 : 1) * k,
        maxLength: y
      };
    } else
      return this.context.fillText(t, u, d), l && (this.context.beginPath(), this.context.moveTo(u, d + n + 2), h === !1 ? this.context.lineTo(u - p, d + n + 2) : this.context.lineTo(e + p, d + n + 2), this.context.stroke()), {
        lengthOfFirstLine: p,
        maxLength: p
      };
  }
  getLabelInfos(t, e, i, r) {
    var n = this.context.measureText(t).width, a = Math.min(Math.max(Math.ceil(n / i), 1), r), l = a * (e + EAnatomyViewer.STYLE.LINE_INTERVAL_PX);
    return LabelToDrawInfos.getOne(l, t, t.length, a);
  }
  setCanvasBackground(t) {
    this.canvasTag.style.backgroundColor = "#" + t;
  }
  hide() {
    this.canvasTag.style.display = "none";
  }
  show() {
    this.canvasTag.style.display = "block";
  }
  static recycleColor(t) {
  }
  getColor(t) {
  }
  static getColorFromHex(t) {
    if (t.charAt(0) == "#" && (t = t.substr(1)), g.COLOR_POOL.AVAILABLE.length > 0)
      var e = g.COLOR_POOL.AVAILABLE.pop();
    else
      var e = { r: 0, g: 0, b: 0 };
    var i = parseInt(t, 16);
    return e.r = i >> 16, e.g = i >> 8 & 255, e.b = i & 255, e;
  }
}
g.COLOR_POOL = {
  AVAILABLE: [
    { r: 0, g: 0, b: 0 },
    { r: 0, g: 0, b: 0 },
    { r: 0, g: 0, b: 0 }
  ]
};
class et {
  constructor(t, e, i) {
    this.a = t, this.b = e, this.color = i, this.accuracy = 0.1;
  }
  getDirection(t = !1) {
    return o.getInstance(t).affect(this.b).substract(this.a).normalize();
  }
  recycle() {
    this.a.recycle(), this.b.recycle();
  }
  setAccuracy(t) {
    this.accuracy = t;
  }
  hasPoint(t) {
    const e = t.distance(this.a), i = this.a.distance(this.b), r = t.distance(this.b);
    return Math.abs(e + r - i) < this.accuracy;
  }
  /**
   *
   * @param {Line} line
   * @return {Vec3}
   */
  getIntersectionWith(t) {
    let e = M.intersection2D(this.a, this.b, t.a, t.b);
    return e !== null && this.hasPoint(e) === !1 && (e = null), e;
  }
}
class T extends b {
  /**
   * @param {Object} settings
   * @param {Object} settings.state
   * @param {PointerState} settings.state.pointer
   * @param {Element} settings.target
   * @param {Object} settings.clickSensitivity threshold whose determine when two click are doubleClick or not.
   * @param {number} settings.clickSensitivity.min minimum time between two clicks in ms, if several click happen only one will be treated
   * @param {number} settings.clickSensitivity.max maximum delay where two click might be treated as double click
   * @param {string} [settings.name] name of the controller
   */
  constructor(t) {
    super({
      name: "pointer-controller",
      ...t
    }), this.target = t.target, this.handlers = {
      pointer: new L({
        domTarget: this.target,
        onMouseMove: this.onMouseMove.bind(this),
        onMouseDown: this.onMouseDown.bind(this),
        onMouseUp: this.onMouseUp.bind(this),
        onClick: this.onClick.bind(this),
        onDoubleClick: this.onDoubleClick.bind(this),
        onMouseEnter: this.onMouseEnter.bind(this),
        onMouseLeave: this.onMouseLeave.bind(this),
        onMouseWheel: this.onMouseWheel.bind(this)
      })
    }, this.state = {
      /** @type {PointerState} **/
      pointer: t.state.pointer || new O()
    };
    const e = t.clickSensitivity || {};
    this.clickSensitivity = {
      min: e.min || 80,
      max: e.max || 200
    }, this.lastClickTimestamp = Date.now(), this.lastDBClickTimestamp = Date.now(), this.longClickTimer = null;
  }
  updatePointerCoords(t) {
    this.state.pointer.update(t), this.state.pointer.data.lastCoordsOnScreen.x = t.clientX, this.state.pointer.data.lastCoordsOnScreen.y = t.clientY;
  }
  clearLongClickTimer() {
    clearTimeout(this.longClickTimer), this.longClickTimer = null;
  }
  enable() {
    this.data.enabled = !0;
  }
  disable() {
    this.data.enabled = !1;
  }
  isEnabled() {
    return this.data.enabled === !0;
  }
  /** @param {PointerEvent} event */
  onMouseMove(t) {
    this.isEnabled() === !0 && (this.updatePointerCoords(t), this.publish(T.EVENT.POINTER_MOVE, t), this.clearLongClickTimer());
  }
  /** @param {PointerEvent} event */
  onMouseDown(t) {
    this.updatePointerCoords(t), this.state.pointer.setMouseDownTarget(t.target), this.state.pointer.isDown = !0;
    const e = Date.now(), i = e - this.lastClickTimestamp;
    if (i <= this.clickSensitivity.min)
      this.lastClickTimestamp = e;
    else {
      if (this.state.pointer.isDown = !0, this.lastClickTimestamp = e, i < this.clickSensitivity.max)
        return this.onDoubleClick(t);
      this.longClickTimer === null && (this.longClickTimer = setTimeout(() => {
        this.publish(T.EVENT.LONG_CLICK);
      }, 500)), this.publish(T.EVENT.POINTER_DOWN, t);
    }
  }
  /** @param {PointerEvent} event */
  onMouseUp(t) {
    this.updatePointerCoords(t), clearTimeout(this.longClickTimer), this.state.pointer.isDown = !1, this.publish(T.EVENT.POINTER_UP, t), t.preventDefault();
  }
  /** @param {PointerEvent} event */
  onMouseEnter(t) {
    this.updatePointerCoords(t), this.publish(T.EVENT.POINTER_ENTER, t);
  }
  /** @param {PointerEvent} event */
  onMouseLeave(t) {
    this.state.pointer.isDown && (this.state.pointer.isDown = !1, this.clearLongClickTimer()), this.publish(T.EVENT.POINTER_LEAVE, t);
  }
  onMouseWheel(t) {
    this.publish(T.EVENT.MOUSE_WHEEL, t);
  }
  /** @param {PointerEvent} event */
  onClick(t) {
  }
  /** @param {PointerEvent} event */
  onDoubleClick(t) {
    const e = Date.now();
    e - this.lastDBClickTimestamp < this.clickSensitivity.min * 2 || (this.lastDBClickTimestamp = e, this.lastClickTimestamp = e, this.publish(T.EVENT.DOUBLE_CLICK, t));
  }
  /**
   * @param {MouseEvent} event
   */
  static isRightClick(t) {
    return t.which === 3 || // old Gecko (Firefox), WebKit (Safari/Chrome) & Opera
    t.button === 2;
  }
}
T.EVENT = {
  POINTER_MOVE: "pointer-move",
  POINTER_DOWN: "pointer-down",
  POINTER_UP: "pointer-up",
  POINTER_ENTER: "pointer-enter",
  POINTER_LEAVE: "pointer-leave",
  LONG_CLICK: "long-click",
  DOUBLE_CLICK: "double-click",
  MOUSE_WHEEL: "mouse-wheel"
};
class Y {
  /**
   * @param {Object} settings
   * @param {any} [settings.container] an indexable object that will hold the resources
   */
  constructor(t = {}) {
    this.availables = t.container || {};
  }
}
class Q extends Y {
  /**
   * @param {Object} settings
   * @param {any} [settings.container] an indexable object that will hold the resources
   */
  constructor(t = {}) {
    super(t), this.default_id = null, this.current_id = null;
  }
}
class J extends Y {
  /**
   * @param {Object} settings
   * @param {any} [settings.container] an indexable object that will hold the resources
   */
  constructor(t = {}) {
    super(t), this.default_id = [], this.current_id = [];
  }
}
class A extends b {
  /**
   *
   * @param {SmartComponentSettings & {resources?: Resource}} settings default resource to store and SmartComponent optional config
   */
  constructor(t = {}) {
    super(t), typeof t.resources < "u" ? this.data.resources = t.resources : this.data.resources = new Y();
  }
  /**
   * @param {string} resource_id
   * @return {boolean} is there a resource referenced with this id ?
   */
  isAvailable(t) {
    return this.findById(t) !== null;
  }
  /**
   * @param {any | {id: string}} resource resource to store
   * @param {string} [resource_id] id of the resource to store
   */
  addResource(t, e = t.id) {
    this.data.resources.availables[e] = t;
  }
  /**
   * @param {string} resource_id id of the resource to look for
   * @return {any|null} requested resource if it exists, `null` otherwise
   */
  findById(t) {
    return this.data.resources.availables[t] || null;
  }
  /**
   * update existing properties of a resource
   * @param {string} resource_id id of the resource to update
   * @param {Record<string, any>} updates collection of properties to update in the resource
   */
  updateById(t, e) {
    const i = this.findById(t);
    for (const r in e)
      i.hasOwnProperty(r) && (i[r] = e[r]);
  }
  /**
   * @return {any} the collection of resources
   */
  getResources() {
    return this.data.resources.availables;
  }
  /**
   * find the first resource holding all of the properties of the given properties collection
   * @param {Record<string, any>} selectors a subset of the properties of the resource to look for
   * @return {null|any} the resource if it exists, `null` otherwise
   */
  findOne(t = {}) {
    const e = Object.values(this.getResources());
    let i = null, r = 0;
    for (; i === null && r < e.length; ) {
      let n = !0;
      const a = e[r];
      Object.keys(t).forEach((l) => {
        const h = t[l];
        a.hasOwnProperty(l) && a[l] === h ? n = n && !0 : (n = !1, r++);
      }), n === !0 && (i = a);
    }
    return i;
  }
  /**
   * find any resources holding all of the properties of the given properties collection
   * @param {Record<string, any>} selectors a subset of the properties of the resource to look for
   * @return {null|any[]} the resources if they exists, `null` otherwise
   */
  find(t = {}) {
    const e = Object.values(this.getResources()), i = Object.keys(t);
    return e.filter((r) => {
      let n = !0;
      return i.forEach((a) => {
        const l = t[a];
        r.hasOwnProperty(a) ? typeof l < "u" && Array.isArray(l.$in) ? n = n && l.$in.indexOf(r[a]) >= 0 : typeof l < "u" && Array.isArray(l.$or) ? n = n && l.$or.some((h) => h === r[a]) : r[a] === l ? n = n && !0 : n = !1 : n = !1;
      }), n;
    });
  }
}
class st extends A {
  /**
   * @param {SmartComponentSettings & {resources?: SelectableOnePerOneResource}} settings default resource to store and SmartComponent optional config
   */
  constructor(t = {}) {
    super(t), this.data.resources = t.resources ?? new Q();
  }
  // region default resource
  /**
   * change which actually stored resource should be used as default
   * @param {string} resource_id id of the resource to set as default
   */
  setDefault(t) {
    if (this.isAvailable(t))
      this.data.resources.default_id = t;
    else
      throw `Unknown resource ${t}`;
  }
  /**
   *
   * @return {any | null} default resource, `null` if there's none
   */
  getDefault() {
    return this.data.resources.availables[this.data.resources.default_id] || null;
  }
  /**
   * @return {string} the id of the default resource if it is set, `null` otherwise
   */
  getDefaultId() {
    return this.data.resources.default_id;
  }
  /**
   * @return {boolean} is there a set default resource ?
   */
  hasDefault() {
    return this.data.resources.default_id !== null;
  }
  /**
   * @param {string} resource_id id of the resource to check
   * @return {boolean} is the given resource the current default one ?
   */
  isDefault(t) {
    return this.getDefaultId() === t;
  }
  // endregion default resource
  // region current resource
  /**
   * set the currently selected resource
   * @param {string} resource_id id of the resource to select
   */
  setCurrent(t) {
    if (this.isAvailable(t))
      this.data.resources.current_id = t;
    else
      throw `Unknown resource ${t}`;
  }
  /**
   *
   * @return {null|any} the currently selected resource, `null` if no resource is selected
   */
  getCurrent() {
    return this.data.resources.availables[this.data.resources.current_id] || null;
  }
  /**
   *
   * @return {string|null} id of the currently selected resource, `null` if no resource is selected
   */
  getCurrentId() {
    return this.data.resources.current_id;
  }
  /**
   * @return {boolean} is there a selected resource ?
   */
  hasContent() {
    return this.getCurrent() !== null;
  }
  /**
   * @param {string} resource_id id of the resource to check
   * @return {boolean} is the given resource the currently selected one ?
   */
  isCurrent(t) {
    return this.getCurrentId() === t;
  }
  // endregion current resource
}
class it extends A {
  /**
   *
   * @param {SmartComponentSettings & {resources?: SelectableMultipleResource}} settings default resource to store and SmartComponent optional config
   */
  constructor(t = {}) {
    super(t), this.data.resources = t.resources ?? new J();
  }
  /**
   * @param {string} resource_id id of the resource to check
   * @return {boolean} is the given resource selected ?
   */
  isSelected(t) {
    return this.data.resources.current_id.has(t);
  }
  /**
   * list all currently selected resources' id
   * @return {string[]} the ids of the currently selected resources
   */
  getCurrentIds() {
    return Array.from(this.data.resources.current_id);
  }
  /**
   * list all currently selected resources
   * @return {any[]} the currently selected resources
   */
  getCurrent() {
    const t = [];
    for (const e of Array.from(this.data.resources.current_id))
      t.push(this.data.resources.availables[e]);
    return t;
  }
  /**
   *
   * @param {string} resource_id id of the resource to toggle
   * @return {boolean} resulting select state of the toggled resource
   */
  toggle(t) {
    return this.isSelected(t) ? (this.select(t), !0) : (this.unselect(t), !1);
  }
  /**
   * @param {string} resource_id id of the resource to select
   * @param {boolean} [mute=false] silences the onSelect action
   */
  select(t, e = !1) {
    try {
      this.data.resources.current_id.add(t), e !== !0 && this.onSelect(t);
    } catch (i) {
      console.error(i);
    }
  }
  // todo : wording, not sure of the correctness of the description
  /**
   * handler for the event fired when selecting a resource
   * @param {string} resource_id id of the selected resource
   */
  onSelect(t) {
  }
  /**
   * remove the given resource from the selected list
   * @param {string} resource_id id of the resource to unselect
   */
  unselect(t) {
    try {
      this.data.resources.current_id.delete(t), this.onUnselect(t);
    } catch (e) {
      console.error(e);
    }
  }
  // todo : wording, not sure of the correctness of the description
  /**
   * handler for the event fired when unselecting a resource
   * @param {string} resource_id id of the unselected resource
   */
  onUnselect(t) {
  }
  /**
   * Mark all resources as selected.
   *
   * /!\ Do not fire the onSelect event.
   */
  selectAll() {
    Object.keys(this.data.resources.availables).forEach((e) => {
      this.select(e, !0);
    });
  }
  /**
   * Marks all resources as unselected.
   *
   * /!\ Do not fire the onUnselect event.
   */
  unselectAll() {
    this.data.resources.current_id.clear();
  }
}
class D extends I {
  /**
   * @param {Object} settings
   * @param {HTMLElement} settings.element Element to be put in fullscreen
   */
  constructor(t) {
    super(), this.initialize = (e) => {
      this.init(e, t);
    };
  }
  /**
   * @param {SmartComponent} component
   * @param {Object} settings
   * @param {HTMLElement} settings.element Element to be put in fullscreen
   * @return {RequestFullscreenFeature} the initialized instance
   */
  init(t, e) {
    return t.store("isFullScreen", !1), D.isSafariIOS() ? this.initFullscreenModeForIOS(t, e.element) : this.initFullscreenMode(t, e.element), this;
  }
  /**
   * @protected
   * @param {SmartComponent} component
   * @param {HTMLElement} element
   */
  onFullScreen(t, e) {
    t.emit("onFullScreen"), t.store("isFullScreen", !0), e.classList.add("fullscreen"), t.publish(X.ON_FULLSCREEN);
  }
  /**
   * @protected
   * @param {SmartComponent} component
   * @param {HTMLElement} element
   */
  onExitFullScreen(t, e) {
    t.emit("onExitFullscreen"), t.store("isFullScreen", !1), e.classList.remove("fullscreen"), t.publish(X.ON_EXIT_FULLSCREEN);
  }
  /**
   * @protected
   * @param {SmartComponent} component
   * @param {HTMLElement} element
   */
  onFullScreenChange(t, e) {
    document[this.getLeaveFullscreenHandler(t).propertyName] !== e && this.onExitFullScreen(t, e);
  }
  /**
   * @protected
   * @param {SmartComponent} component
   * @param {HTMLElement} element
   */
  initFullscreenModeForIOS(t, e) {
    const i = document.body, r = (n) => {
      try {
        n.preventDefault();
      } catch (a) {
        t.notifyError(a);
      }
    };
    t.setBehavior("toggleFullScreen", () => {
      t.get("isFullScreen") === !1 ? (e.classList.add("fullscreen"), i.classList.add("no-scroll"), i.ontouchmove = r, i.parentElement.ontouchmove = r, e.style.height = window.innerHeight + "px") : (e.classList.remove("fullscreen"), i.classList.remove("no-scroll"), i.ontouchmove = null, i.parentElement.ontouchmove = null, e.style.height = "");
    });
  }
  /**
   * @protected
   * @param {SmartComponent} component
   * @param {HTMLElement} element
   */
  initFullscreenMode(t, e) {
    const i = this.getFullscreenHandler(t, e);
    t.listen(i.eventName, () => {
      this.onFullScreenChange(t, e);
    }), i.eventName !== "fullscreenchange" && t.listen("fullscreenchange", () => {
      this.onFullScreenChange(t, e);
    }), t.setBehavior("toggleFullScreen", () => {
      t.get("isFullScreen") === !1 ? (i.requestFullScreen(), this.onFullScreen(t, e)) : (i.exitFullscreen(), this.onExitFullScreen(t, e));
    });
  }
  /**
   * @protected
   * @param {SmartComponent} component
   * @param {HTMLElement} element
   * @return {{requestFullScreen: function(): void, eventName: string}}
   */
  getOpenFullscreenHandler(t, e = document.body) {
    let i, r;
    return typeof e.requestFullscreen == "function" ? (i = "requestFullscreen", r = "fullscreenChange") : typeof e.mozRequestFullScreen == "function" ? (i = "mozRequestFullScreen", r = "mozfullscreenchange") : typeof e.webkitRequestFullscreen == "function" ? (i = "webkitRequestFullScreen", r = "webkitfullscreenchange") : typeof e.msRequestFullscreen == "function" && (i = "msRequestFullscreen", r = "MSFullscreenChange"), {
      requestFullScreen() {
        try {
          e[i]();
        } catch (n) {
          t.notifyError(n);
        }
      },
      eventName: r
    };
  }
  /**
   * @protected
   * @param {SmartComponent} component
   * @return {{exitFullscreen: function(): void, propertyName: string}}
   */
  getLeaveFullscreenHandler(t) {
    let e = null, i = null;
    if (typeof document.exitFullscreen == "function")
      e = "exitFullscreen";
    else if (typeof document.webkitExitFullscreen == "function")
      e = "webkitExitFullscreen";
    else if (typeof document.mozCancelFullScreen == "function")
      e = "mozCancelFullScreen";
    else if (typeof document.msExitFullscreen == "function")
      e = "msExitFullscreen";
    else
      throw new Error("No exit fullscreen method");
    if ("fullscreenElement" in document)
      i = "fullscreenElement";
    else if ("webkitFullscreenElement" in document)
      i = "webkitFullscreenElement";
    else if ("mozFullScreenElement" in document)
      i = "mozFullScreenElement";
    else if ("msFullscreenElement" in document)
      i = "msFullscreenElement ";
    else
      throw new Error("No fullscreen element property");
    return {
      exitFullscreen() {
        if (i === null || document[i])
          try {
            document[e]();
          } catch (r) {
            t.notifyError(r);
          }
      },
      propertyName: i
    };
  }
  /**
   *
   * @param {SmartComponent} component
   * @param {HTMLElement} element
   * @return {{exitFullscreen: function(): void, requestFullScreen: function(): void, eventName: string}}
   */
  getFullscreenHandler(t, e = document.body) {
    return {
      ...this.getOpenFullscreenHandler(t, e),
      ...this.getLeaveFullscreenHandler(t)
    };
  }
  /**
   * sniff the user agent to find if we're running on safari
   * @return {Boolean}
   */
  static isSafariIOS() {
    return navigator.userAgent.match(/(iPod|iPhone|iPad)/) !== null && navigator.userAgent.match(/AppleWebKit/) !== null;
  }
}
const X = {
  ON_FULLSCREEN: "onFullscreen",
  ON_EXIT_FULLSCREEN: "onExitFullscreen"
};
function rt(s, t) {
  return new D(t);
}
const nt = "1.1.10";
export {
  I as Feature,
  M as Geometry,
  g as ImaiosCanvas,
  F as KeyboardController,
  et as Line,
  N as Listenable,
  L as MouseController,
  T as PointerController,
  O as PointerState,
  H as PublisherSubscriberFeature,
  D as RequestFullscreenFeature,
  X as RequestFullscreenFeatureEVENT,
  rt as RequestFullscreenFeatureFactory,
  Y as Resource,
  A as ResourceManagerService,
  J as SelectableMultipleResource,
  it as SelectableMultiplesResourceManagerService,
  Q as SelectableOnePerOneResource,
  st as SelectableOnePerOneResourceManagerService,
  b as SmartComponent,
  K as TransformMatrix,
  o as Vec3,
  nt as version
};
//# sourceMappingURL=im-jsdk.js.map
